import React from 'react';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="bg-[#fffcf1] min-h-screen text-gray-800">
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
        
        {/* Header Section */}
        <div className="text-center mb-12 -mt-6 md:-mt-10">
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-[#334a21] mb-4">
            Terms & Conditions
          </h1>
          <p className="text-gray-500 text-sm md:text-base">
            Please read these terms carefully before using our services.
          </p>
          <div className="h-1 w-20 bg-[#334a21] mx-auto mt-3 rounded-full opacity-20"></div>
        </div>

        {/* Content Section */}
       <div className="space-y-8 leading-relaxed text-gray-700">
          
          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">1. General Overview</h2>
            <p>
              By accessing or using the AyushVatika website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">2. Products & Services</h2>
            <p>
              AyushVatika specializes in herbal and ayurvedic products. While we strive to display our products accurately, actual product packaging may vary. All products are subject to availability. We reserve the right to discontinue any product at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">3. Medical Disclaimer</h2>
            <p className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400 text-sm md:text-base">
              <strong>Note:</strong> The products and information provided on this website are not intended to diagnose, treat, cure, or prevent any disease. Always consult with a healthcare professional before starting any new herbal regimen, especially if you have pre-existing medical conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">4. Pricing & Payments</h2>
            <p>
              All prices are listed in INR (Indian Rupees) and are inclusive of applicable taxes unless stated otherwise. We reserve the right to change prices without notice. Payment must be received in full before products are dispatched.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">5. Shipping & Returns</h2>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>Orders are typically processed within 24-48 hours.</li>
              <li>Delivery times may vary based on location.</li>
              <li>We accept returns only for damaged or incorrect items received. Please report any issues within 48 hours of delivery.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">6. Intellectual Property</h2>
            <p>
              All content on this website, including text, graphics, logos, and images, is the property of AyushVatika and is protected by copyright laws. Unauthorized use of any content is strictly prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#334a21] mb-3">7. Changes to Terms</h2>
            <p>
              AyushVatika reserves the right to modify these terms at any time. Changes will be effective immediately upon posting on the website. Your continued use of the site constitutes acceptance of the revised terms.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;